import React from "react";

const notFoundText = `Apologies, page not found.`;

function NotFound(props) {
  return (
    <div>
      <p>{notFoundText}</p>
    </div>
  );
}

export default NotFound;
